import axios from 'axios';
import {API} from '@/services/url';

/**
 * Monitoring: the live board and the systems registry.
 *
 * Every call takes BOTH a success and an error callback and always invokes exactly one of them.
 * Omitting the error callback throws inside the caller's created() hook and takes the page down.
 */
export default {

	getLive: function (params, success, error) {
		axios.get(API.monitoring.live, {params: params || {}})
			.then(r => success(r.data))
			.catch(e => error(readMessage(e, 'Could not load the monitoring board')));
	},

	getTrend: function (params, success, error) {
		axios.get(API.monitoring.trend, {params: params || {}})
			.then(r => success(r.data))
			.catch(e => error(readMessage(e, 'Could not load response trends')));
	},

	getSummary: function (params, success, error) {
		axios.get(API.monitoring.summary, {params: params || {}})
			.then(r => success(r.data))
			.catch(e => error(readMessage(e, 'Could not load the monitoring summary')));
	},

	getSystems: function (success, error) {
		axios.get(API.monitoring.systems)
			.then(r => success(r.data))
			.catch(e => error(readMessage(e, 'Could not load systems')));
	},

	createSystem: function (system, success, error) {
		axios.post(API.monitoring.systems, system)
			.then(r => success(r.data))
			.catch(e => error(readMessage(e, 'Could not create the system')));
	},

	updateSystem: function (id, system, success, error) {
		axios.put(API.monitoring.system(id), system)
			.then(r => success(r.data))
			.catch(e => error(readMessage(e, 'Could not update the system')));
	},

	deleteSystem: function (id, success, error) {
		axios.delete(API.monitoring.system(id))
			.then(r => success(r.data))
			.catch(e => error(readMessage(e, 'Could not remove the system')));
	}
};

function readMessage(e, fallback) {
	if (e && e.response && e.response.data && e.response.data.message) return e.response.data.message;
	if (e && e.message) return e.message;
	return fallback;
}
